import { render, staticRenderFns } from "./EmTabPane.vue?vue&type=template&id=057564e2&scoped=true&"
import script from "./EmTabPane.vue?vue&type=script&lang=js&"
export * from "./EmTabPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057564e2",
  null
  
)

export default component.exports